<mat-card class="cmp-container">
  <div></div>
  <div class="image-container" [style.backgroundImage]="'url(' + backgroundUrl + ')'">
    <div class="top"></div>
    <div>
      <h1> {{ title | uppercase }}</h1>
    </div>
    <div class="actions">
        <div class="time-picker">
          <period-picker [input_picker_start_date]="datePickerStartDate" [input_picker_end_date]="datePickerEndDate" [input_picker_mode]="datePickerMode" (periodChange)="onTimePeriodChange($event)"></period-picker>
        </div>
    
        <div>
          <div class="course-links">
            <button *ngFor="let additionalAction of additionalActions" mat-button color="primary"
              [ngClass]="additionalAction.button.raised ? 'mat-raised-button' : 'mat-stroked-button course-link'"
              (click)="performAction(additionalAction)"
            >
              <mat-icon *ngIf="!additionalAction.button.fontAwesomeIcon">{{ additionalAction.button.icon }}</mat-icon>
              <mat-icon *ngIf="additionalAction.button.fontAwesomeIcon" fontSet="fa" [fontIcon]="additionalAction.button.icon"></mat-icon>
              <span>{{ additionalAction.button.label | uppercase}}</span>
            </button> 

          </div>
        </div>
      </div>
    </div>
</mat-card>
